import { useEffect, useState } from 'react';

import { SharedState } from './SharedState';

export function useSharedState<Value>(
  container: SharedState<Value>,
): [Value, SharedState<Value>['setValue']] {
  const [value, setValue] = useState(container.value);

  useEffect(() => {
    return container.subscribe(setValue);
  }, [container, setValue]);

  return [value, container.setValue.bind(container)];
}
